import React from "react";
import Footer from "../../assets/images/Footer.png";

const AuthorizationTimeout = () => {
  return (
    <div className="md:w-[562px] w-[300px] mt-40">
      <div className="flex  justify-between">
        <p className="text-orangeCard text-xl font-bold">Tribe</p>
        <div>
          <p className="text-2xl text-orangeCard font-bold">
            <span className="text-xl">NGN</span> 12,839.2
          </p>
          <p className="text-sm text-orangeCard font-normal">
            (Fee NGN 100.00)
          </p>
          <p className="text-[17.75px] text-normalText font-normal">
            mbonnudebbie@gmail.com
          </p>
        </div>
      </div>
      <div className="flex justify-center">
        <p className="text-[18.75px] font-normal text-darkGrey text-center mt-10 w-[348px]">
          Authorisation of the amount has not been confirmed
        </p>
      </div>
      <span className="flex justify-center mt-10">
        <svg
          width="69"
          height="69"
          viewBox="0 0 69 69"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.8514 60.3751H56.1489C60.5764 60.3751 63.3364 55.5738 61.1226 51.7501L39.4739 14.3463C37.2601 10.5226 31.7401 10.5226 29.5264 14.3463L7.8776 51.7501C5.66385 55.5738 8.42385 60.3751 12.8514 60.3751ZM34.5001 40.2501C32.9189 40.2501 31.6251 38.9563 31.6251 37.3751V31.6251C31.6251 30.0438 32.9189 28.7501 34.5001 28.7501C36.0814 28.7501 37.3751 30.0438 37.3751 31.6251V37.3751C37.3751 38.9563 36.0814 40.2501 34.5001 40.2501ZM37.3751 51.7501H31.6251V46.0001H37.3751V51.7501Z"
            fill="#F4B70A"
          />
        </svg>
      </span>
      <div className="flex flex-col items-center mt-4">
        <p className="text-2xl font-semibold text-darkTheme">
          Transaction Timeout
        </p>
        <p className="text-sm font-normal text-darkTheme">
          Your transaction was not successful
        </p>
      </div>
      <div className="flex justify-center mt-10">
        <button className=" text-white text-[14.75px] w-[307px] rounded-[10px] bg-orangeCard py-[20.19px]">
          Redirect in: 00:30
        </button>
      </div>
      <div className="flex justify-center mt-6 mb-2">
        <img src={Footer} alt="footerLogo" className="w-[227px]" />
      </div>
    </div>
  );
};

export default AuthorizationTimeout;
